import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { TermsHookResult } from "./Terms.types.tsx";

import { getTerms } from "../../services/legal.services.tsx";

export const useTerms = (): TermsHookResult => {
  const { i18n } = useTranslation();

  const [terms, setTerms] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchTerms = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);

      const language = i18n.language.split("-")[0];

      const response = await getTerms(language);

      setTerms(response);
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "API Error";
      toast.error(`Error: ${message}`);
    } finally {
      setIsLoading(false);
    }
  }, [i18n.language]);

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  return {
    terms,
    isLoading,
  };
};
